<template>
  <div>
    Notification
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>